import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { finalize, share, tap } from 'rxjs/operators';
import { InvoiceDetailsDto } from '../dtos/invoice-details-dto.model';
import { ConfigService } from './config.service';
import { SwalAlert } from '../helpers/alert';
import { ModeService } from './mode.service';

@Injectable({
  providedIn: 'root'
})

export class InvoicesService {
  hasCCMemo = false;
  getInvoicesEmitterForOrderId = new Subject<InvoiceDetailsDto[]>();
  invoiceResults: InvoiceDetailsDto[] | undefined;
  invoiceResultsWithFilter: InvoiceDetailsDto[] = [];
  configIsReadySubscription: Subscription | undefined;
  private readonly _httpClient: HttpClient;
  private readonly _configService: ConfigService;
  invoiceDetailsCache!: InvoiceDetailsDto[] | null;
  invoiceDetailsCachedObservable!: Observable<InvoiceDetailsDto[]> | null;
  swalAlert = new SwalAlert();
  private readonly _modeService: ModeService;

  constructor(httpClient: HttpClient, configService: ConfigService, modeService: ModeService) {
    this._httpClient = httpClient;
    this._configService = configService;
    this._modeService = modeService;
  }

  getInvoicesWithOrderId(orderId: number, selectedVal: string): void {
    this.invoiceResultsWithFilter = [];
    let observable: Observable<InvoiceDetailsDto[]>;
    let loadingInvoicesMsg = "Loading invoices for Order " + orderId;
    this._modeService.addToWaitList(loadingInvoicesMsg);
    if (this.invoiceDetailsCache) {
      observable = of(this.invoiceDetailsCache);
    }
    else if (this.invoiceDetailsCachedObservable) {
      observable = this.invoiceDetailsCachedObservable;
    }
    else {
      this.invoiceDetailsCachedObservable = this._httpClient.get<InvoiceDetailsDto[]>(`${this._configService.apiUrl}/Accounting/GetInvoiceByOrderId?orderId=${orderId}`)
        .pipe(
          tap((response: InvoiceDetailsDto[]) => {
            this.invoiceDetailsCache = response;
          }),
          share(),
          finalize(() => {
            this.invoiceDetailsCache = null;
            this.invoiceDetailsCachedObservable = null;
          })
        )

      observable = this.invoiceDetailsCachedObservable;
    }

    observable.subscribe((data: InvoiceDetailsDto[]) => {
      this.invoiceResults = data;

      if (selectedVal.toLowerCase() === 'all') {
        this.invoiceResultsWithFilter = [...this.invoiceResults];
      }
      else {
        this.invoiceResults.forEach(element => {
          if (element.balance !== 0) {
            this.invoiceResultsWithFilter.push(element);
          }
        });
      }

      this.getInvoicesEmitterForOrderId.next(this.invoiceResultsWithFilter);
      this._modeService.removeFromWaitList(loadingInvoicesMsg);
    }, (error: any) => {
      console.log(error);
      this.swalAlert.alert('An error occurred while getting the invoice details.');
      this._modeService.removeFromWaitList(loadingInvoicesMsg);
    });
  }
}
